import { type ReactElement } from 'react'
import * as S from './numbers.styled'
import SlotCounter from 'react-slot-counter'
import family from './assets/family.svg'
import map from '../../assets/images/map.svg'
import partner from './assets/partner.svg'
import microscope from '../../assets/images/microscope.svg'
import { NumberCard } from '../number-card/number-card'
import google from './assets/google-play.png'
import apple from './assets/apple-store.png'
import reclame from './assets/reclame-aqui.png'

export function Numbers (): ReactElement {
  return <S.Container>
    <S.Content>
      <h1>Números que temos orgulho de ter alcançado</h1>
      <S.NumbersGrid>
        <NumberCard icon={family} subtext="<strong>Famílias atendidas</strong> na América Latina">
          <span>
            +
            <SlotCounter animateOnVisible duration={2} direction="top-down" value={7} />
          </span>
          {' '}
          milhões
        </NumberCard>
        <NumberCard icon={map} subtext="Na América Latina <strong>em expansão</strong>">
          <SlotCounter animateOnVisible duration={2} direction="top-down" value={450} />
          {' '}
          unidades
        </NumberCard>
        <NumberCard icon={partner} subtext="Estabelecimentos <strong>parceiros</strong>">
          <span>
            +
            <SlotCounter animateOnVisible duration={2} direction="top-down" value={12} />
          </span>
          {' '}
          mil
        </NumberCard>
        <NumberCard icon={microscope} subtext="Exames feitos nas clínicas parceiras <strong>AmorSaúde</strong>">
          <SlotCounter animateOnVisible duration={2} direction="top-down" value={500} />
          {' '}
          mil
        </NumberCard>
        <NumberCard logo={google} subtext="estrelas no <strong>Google Play</strong>">
          <SlotCounter animateOnVisible duration={2} direction="top-down" value={4.6} />
        </NumberCard>
        <NumberCard logo={apple} subtext="estrelas na <strong>Apple Store</strong>">
          <SlotCounter animateOnVisible duration={2} direction="top-down" value={4.9} />
        </NumberCard>
        <NumberCard logo={reclame} subtext="índice de <strong>soluções</strong>">
          <span><SlotCounter animateOnVisible duration={2} direction="top-down" value={90} />%</span>
        </NumberCard>
      </S.NumbersGrid>
    </S.Content>
    <S.Background />
  </S.Container>
}
